import {
  ButtonStyleShapeTypes,
  QuestionType,
  QuestionTypeVariantType,
} from 'shared/types';
import config from 'utils/config';
import { EMOJI_PICK_HELPER, TYPE_VARIANT_CHOICES_PNG } from './constants';

export const getRadius = (shape: ButtonStyleShapeTypes) => {
  switch (shape) {
    case 'curved':
      return '4px';
    case 'rounded':
      return '50%';
    case 'square':
      return '0';
  }
};

export const getIconUrl = ({
  max,
  position,
  question_type,
  type_variant,
}: {
  max: number;
  position: number;
  question_type?: QuestionType | null;
  type_variant?: QuestionTypeVariantType | null;
}): string => {
  if (
    type_variant === 'THUMBS' ||
    type_variant === 'TICK' ||
    (question_type === 'BOOLEAN' && type_variant)
  ) {
    return `${config.EXTERNAL_ASSET_URL}/icons/${TYPE_VARIANT_CHOICES_PNG?.[type_variant]?.[position]}.png`;
  }
  if (type_variant === 'EMOJI')
    return `${config.EXTERNAL_ASSET_URL}/icons/smile-${
      EMOJI_PICK_HELPER?.[max]?.[position - 1]
    }.png`;
  if (type_variant === 'STAR')
    return `${config.EXTERNAL_ASSET_URL}/icons/star.png`;
  return '';
};
